import { i18n } from "@lingui/core";

/**
 * Load messages for requested locale and activate it.
 * This function isn't part of the LinguiJS library because there are
 * many ways how to load messages — from REST API, from file, from cache, etc.
 */
export async function loadCatalog(locale: string): Promise<void> {
  const catalog = (await import(`../locales/${locale}.po`)) as {
    messages: Record<string, string>;
  };
  i18n.loadAndActivate({ locale, messages: catalog.messages });
}
